import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { UserLayoutComponent } from './components/layouts/user-layout.component';
import { GuestLayoutComponent } from './components/layouts/guest-layout.component';
import {AppRoutingModule} from './app.routing.module';
import {SidebarComponent} from './components/sidebar/sidebar.component';
import {StatusBarComponent} from './components/status-bar/status-bar.component';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgxWebstorageModule} from 'ngx-webstorage';
import {ToastrModule} from 'ngx-toastr';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AuthInterceptor} from './interceptors/auth.interceptor';
import { SocketIoModule } from 'ngx-socket-io';
import { environment } from '../environments/environment';
import { DomHub } from './sockets/dom.hub';
import { DatePipe } from '@angular/common';
import { DialogModule } from '@angular/cdk/dialog';
import { MobileNavComponent } from './components/mobile-nav/mobile-nav.component';

@NgModule({
  declarations: [
    AppComponent,
    UserLayoutComponent,
    GuestLayoutComponent,
    SidebarComponent,
    StatusBarComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    DialogModule,
    ToastrModule.forRoot(),
    BsDropdownModule.forRoot(),
    NgxWebstorageModule.forRoot({
      prefix: 'admin.siq.provispo.tv',
      separator: '.',
      caseSensitive: true
    }),
    SocketIoModule.forRoot({ url: environment.dispatchUrl, options: {} }),
    MobileNavComponent,
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    DomHub,
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
